import {fetchGet, fetchPost} from "../services/api";
import {IPlaylist, IPlaylistsResync} from "../models/playlist";

export const fetchPlaylists = (): Promise<IPlaylist[]> => {
    return fetchGet( '/playlists')
        .then(data => {
            return data.data || [];
        });
};
